/* eslint-disable import/prefer-default-export */

export const isNeedWrapper = (length) => !length || length >= 1300;
